import { Box, Stack, Typography } from "@mui/material";

interface HeroSectionProps {
  title: string;
  subtitle: string;
}

const HeroSection = ({ title, subtitle }: HeroSectionProps) => {
  return (
    <Stack
      sx={{
        pt: { xs: "20px", md: "80px" },
        pb: { xs: "32px", md: "48px" },
        px: { xs: 3, sm: 4, md: 0 },
        alignItems: "center",
      }}
      spacing={{ xs: 2, md: 2.5 }}
    >
      {/* Pill badge */}
      <Box
        sx={{
          display: "inline-block",
          border: "1px solid #d4d4d4",
          color: "#737373",
          fontSize: "11px",
          fontFamily: "Mulish",
          fontWeight: 500,
          letterSpacing: "0.1em",
          px: "16px",
          py: "8px",
          borderRadius: "9999px",
          textTransform: "uppercase",
        }}
      >
        Over 100k people connected
      </Box>

      {/* Heading */}
      <Typography
        component="h2"
        sx={{
          fontFamily: "Mulish",
          fontWeight: 800,
          fontSize: { xs: "36px", sm: "42px", md: "48px" },
          color: "#1A1A1A",
          textAlign: "center",
          letterSpacing: "-0.035em",
          lineHeight: 1.15,
          maxWidth: { xs: "100%", md: "760px" },
        }}
      >
        {title}
      </Typography>

      {/* Subtitle */}
      <Typography
        sx={{
          fontFamily: "Mulish",
          fontWeight: 400,
          fontSize: { xs: "15px", md: "17px" },
          color: "#737373",
          textAlign: "center",
          lineHeight: 1.7,
          maxWidth: { xs: "90%", md: "640px" },
        }}
      >
        {subtitle}
      </Typography>
    </Stack>
  );
};

export default HeroSection;
